import { createFileRoute } from '@tanstack/react-router';
import { MyDraftsPage } from '@/features/metric-hub/inbox/MyDraftsPage';
import { useTrackSkillOnDwell } from '@/features/metric-hub/onboarding/use-skill-tracker';

function MyDraftsRoute() {
  useTrackSkillOnDwell('view_my_drafts');
  return <MyDraftsPage />;
}

export const Route = createFileRoute('/_authed/metric-hub/my-drafts')({
  component: MyDraftsRoute,
});
